import Button from "@web-ui/components/Button";
import type { ChangesView } from "@/api/admin";
import { relative } from "@/lib/format";
import { pillText } from "@/publishing/changes";

/** Changes not live: how many, and the way to Review & publish (or what is live). */
export function ChangesNotLive({ changes, reviewHref }: { changes: ChangesView | null; reviewHref: string }) {
  const pending = changes?.changes.length ?? 0;
  return (
    <section className="card flex flex-wrap items-center gap-3" aria-labelledby="not-live">
      <div className="me-auto min-w-0 ps-card-inset py-1">
        <h2 id="not-live" className="text-sub-title-1">Changes not live</h2>
        <p className="text-body-2 text-t-secondary">
          {!changes ? "Checking…" : pending ? `${pillText(pending)}. They reach the apps when you publish.` : changes.live ? `${pillText(0)}. Last published ${relative(Date.parse(changes.live.publishedAt))}.` : "Nothing is published yet."}
        </p>
      </div>
      {pending ? <Button as="a" variant="primary" href={reviewHref}>Review & publish</Button> : <Button as="a" variant="outline" size="sm" href={reviewHref}>See what is live</Button>}
    </section>
  );
}
